import { Client } from './client'

export const getApiClient = (baseUrl: string): [Client, AbortController] => {
  const controller = new AbortController();
  const { signal } = controller;

  let client = new Client(baseUrl, {
    fetch: async (url: RequestInfo, init?: RequestInit) => {
      return await fetch(url, {
        ...init,
          headers: {
              ...init?.headers
        },
        signal
      });
    }
  })

  return [client, controller]
}

export * from './client'